/**
 * @class ServerLogger
 * Moved to top because syntax errors above this declaration would not be reported
 * !! IMPORTANT !! This file should not use jquery since it is loaded at the
 * very top of all pages and we use multiple versions of jquery across the site
 */

if (typeof M === "undefined") {
  M = {}; // Minted namespace
}

function ServerLogger(namespace) {
  this.namespace = namespace;
  this.countSends = 0;
}

// Each CU3 browser session is limited
// to the number of server log messages.
ServerLogger.MAX_SENDS = 100;

ServerLogger.prototype.log = function(msg) {
  this._send('INFO', msg);
  console.log(msg);
};

ServerLogger.prototype.debug = function(msg) {
  this._send('DEBUG', msg);
  console.debug(msg);
};

ServerLogger.prototype.warn = function(msg) {
  this._send('WARN', msg);
  console.warn(msg);
};

ServerLogger.prototype.error = function(msg, opts) {
  this._send('ERROR', msg, opts);
  console.error(msg);
};

/**
 * log client errors on the server
 *
 * Disabled for ticket https://jira.mntd.net/browse/EC-7790, not using these
 * logs anymore, but may potentially use in the future for client logging
 *
 * @param level {String} the level of logging (e.g. DEBUG, ERROR, LOG, etc)
 * @param msg {String} message to log
 * @param opts {Object} dictionary of options
 */
ServerLogger.prototype._send = function(level, msg, opts) {
  // this.countSends++;
  // if (this.countSends > ServerLogger.MAX_SENDS) {
  //   console.warn('Ignoring message.  ServerLogger has reached its quota.');
  //   return;
  // }

  // if (typeof msg != 'string') {
  //   throw 'Invalid msg';
  // }

  // // NOTE: M.LOG_MODULE_VIEW might not be always be available -- some templates
  // // don't define it or an error might be fired before it gets set
  // var data = {
  //   level:   level,
  //   msg:     msg,
  //   module:  M.LOG_MODULE_VIEW,
  //   url:     window.location.href,
  //   browser: navigator.userAgent,
  //   referer: document.referrer
  // };
  //
  // // Merge data & opts.
  // for (var k in opts || {}) {
  //   var v = opts[k];
  //   data[k] = v;
  // }
  //
  // /*
  //  * this is loaded very early so CDN_VERSION  is not always available
  //  */
  // if (typeof CDN_VERSION != "undefined") {
  //   data.cdnVersion = CDN_VERSION;
  // }
  //
  // We won't have jquery when we load this file, so do an ajax request manually
  // var xhr = new XMLHttpRequest();
  // var paramsList = [];
  // for (var key in data) {
  //   var value = data[key];
  //   var param = encodeURIComponent(key) + "=" + encodeURIComponent(value);
  //   param = param.replace( /%20/g, "+" );
  //   paramsList.push(param);
  // }
  // var postData = paramsList.join( "&" ).replace( /%20/g, "+" );
  //
  // xhr.open('POST', '/personalize/client_logger');
  // xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded; charset=UTF-8");
  // xhr.setRequestHeader("X-Requested-With", "XMLHttpRequest");
  // xhr.send(postData);

};

// Define a server logger.
var _serverLogger = new ServerLogger();
